export default "__VITE_ASSET__Oh6nMuQM__"